// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2z-Ku","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3eDGn"};